import * as React from "react";
import { SpinnerWrapper, ButtonType, CustomButton, AlertMessage, AlertType, PaginationNavigation } from "soprasteria-ui-library";
import { useAuth } from "../../../App";
import { IPagination } from "soprasteria-ui-library/dist/models/IPagination";
import { setMessage } from "../../../helpers/MessageHelper";
import { IPage } from "../../../models/IPage";
import { IPaginatedResponse } from "../../../api/ApiClient";
import { IPatientRefrainingFreeDentalCare } from "../../../models/IPatient";
import { PatientApi } from "../../../api/PatientApi";
import { PatientsRefrainingFreeDentalCareTable } from "./PatientsRefrainingFreeDentalCareTable";
import { useHistory } from "react-router";
import { PATIENTS_REFRAINING_FREE_DENTAL_CARE } from "../../../utils/RouteConstants";

export const PatientsRefrainingFreeDentalCare: React.FunctionComponent<{}> = () => {
    const auth = useAuth();
    const api = new PatientApi(auth);
    const history = useHistory();
    const abortController = new AbortController();
    const [patientsRefrainingFreeDentalCare, setPatientsRefrainingFreeDentalCare] = React.useState<IPatientRefrainingFreeDentalCare[]>();
    const [pagingParameters, setPagingParameters] = React.useState<IPage>();
    const [paginationHeader, setPaginationHeader] = React.useState<IPagination>();
    const pageSize = 20;
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [isFetching, setIsFetching] = React.useState<boolean>(false);
    const [isExportingToExcel, setIsExportingToExcel] = React.useState<boolean>(false);

    const loadPatientsRefrainingFreeDentalCare = (pagingParams: IPage) => {
        setIsFetching(true);
        pagingParams.pageSize = pageSize;
        pagingParams.pageNumber = pagingParams.pageNumber ?? 1;
        history.push(PATIENTS_REFRAINING_FREE_DENTAL_CARE, pagingParams);
        
        api.getPatientsRefrainingFreeDentalCare(pagingParams, (result: IPaginatedResponse<IPatientRefrainingFreeDentalCare[]>) => {
            setPatientsRefrainingFreeDentalCare(result.data);
            setPaginationHeader(result.paginationHeader);
        }, (message) => {
            const newErrorMessage = setMessage(message, errorMessage);
            setErrorMessage(newErrorMessage);
        }, () => {
            setIsFetching(false); 
        });

        setPagingParameters(pagingParams);
    }

    React.useEffect(() => {
        if (history.location.state !== undefined && history.location.state !== null) {
            const lastPagingParams = ((history.location.state) as any) as IPage;
            loadPatientsRefrainingFreeDentalCare(lastPagingParams);
        }
        else {
            loadPatientsRefrainingFreeDentalCare({ pageSize: pageSize, pageNumber: 1 });
        }
        return () => {
            abortController.abort();
        }
    }, []);

    const onPageSelect = (pageNumber: number) => {
        if (pagingParameters) {
            const currentPagingParams = pagingParameters;
            currentPagingParams.pageNumber = pageNumber;
            loadPatientsRefrainingFreeDentalCare(currentPagingParams);
        }
    }

    const exportToExcel = () => {
        if (pagingParameters) {
            setIsExportingToExcel(true);
            api.getPatientsRefrainingFreeDentalCareAsExcel(pagingParameters, "Patinter som avstår avgiftsfri tandvård", undefined, undefined, () => setIsExportingToExcel(false));
        }
    }

    return (
        <SpinnerWrapper isLoading={isFetching}>
            <section className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col">
                            <h1>Patienter som avstår avgiftsfri tandvård</h1>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
                    <div className="panel text-right">
                        <div className="btn-group" role="group">
                            <CustomButton buttonType={ButtonType.excel} 
                                buttonText="Exportera till excel"
                                isLoading={isExportingToExcel}
                                onClick={() => exportToExcel()} />
                        </div>
                    </div>
                    <PatientsRefrainingFreeDentalCareTable patients={patientsRefrainingFreeDentalCare} />
                    <PaginationNavigation
                        ariaLabel="patients refraining free dental care pagination"
                        pagination={paginationHeader}
                        selectedPage={page => onPageSelect(page)}
                        pageNeighbours={2}
                        showCount={true}
                    />
                </div>
            </section>
        </SpinnerWrapper>
    )
}